import React from "react";

export const startModal = () => ({
  title: "Welcome to Quiz 2010!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        How well do you remember 2010? 🕰️
      </div>
      <div className="modal-description-contents">
        <p>
          You’ll face <strong>12 questions</strong> spanning the biggest movie
          blockbusters, chart-topping hits, viral internet moments, and
          jaw-dropping news stories from 2010.
        </p>
      </div>
      <div className="modal-description-footer">
        Let’s see how strong your 2010 memory really is!
      </div>
    </div>
  ),
  buttonText: "Start",
  buttonType: "start",
});

export const resultModal = (correct, explanation, isLast) => ({
  title: correct ? "Correct ✅" : "Wrong ❌",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title"></div>
      <div className="modal-description-contents">
        <p>{explanation}</p>
      </div>
    </div>
  ),
  buttonText: isLast ? "Finish" : "Next",
  buttonType: "start",
});

export const finalModal = (score, total, restartQuiz) => ({
  title: "Quiz Complete!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-contents">
        <p>
          You scored <strong>{score}</strong> out of <strong>{total}</strong>.
        </p>
      </div>
      <div className="modal-description-footer">
        Want to give it another shot?
      </div>
    </div>
  ),
  buttonText: "Play Again",
  buttonType: "start",
  onClose: restartQuiz,
});
